/* Prossimo corso: circa una settimana dopo oggi, sempre lun/mar/mer della settimana successiva. */
export const nextCourseDateLabel = () => {
    const t = new Date();
    t.setHours(0, 0, 0, 0);
    t.setDate(t.getDate() + 7);
    const wd = t.getDay();
    if (wd < 1 || wd > 3) {
        t.setDate(t.getDate() + (((8 - wd) % 7) || 7));
    }
    const giorni = ["dom", "lun", "mar", "mer", "gio", "ven", "sab"];
    const mesi = ["gen", "feb", "mar", "apr", "mag", "giu", "lug", "ago", "set", "ott", "nov", "dic"];
    return `${giorni[t.getDay()]} ${t.getDate()} ${mesi[t.getMonth()]}`;
};
